﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

interface ITooltipScope extends ng.IScope {
    label?: string;
    media?: string;
    helpUrl?: string;
    desc?: string;

    _close?: () => void;
}

@NgComponent({
    token: Token.KbTooltip,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbTooltip extends Directive {
    constructor(
        $timeout: ng.ITimeoutService
    ) {
        super();

        this.restrict = "EA";
        this.scope = {
            label: "=?",
            media: "=?",
            helpUrl: "=?",
            desc: "=?"
        };
        this.replace = true;
        this.transclude = true;
        this.template = Dirs.component("kb-tooltip");
            
        this.link = (scope: ITooltipScope, element: JQuery, atts: any) => {
            
        };
    }
}
